import DashboardPage from '@components/pages/dashboard'
import { TableWrapper } from '@/ui/components/CustomTable/CustomTable.styles'
import Typography from '@/ui/components/typography'
import { InlineScanIndicator } from '@/ui/components/inline-scan-indicator'
import { TitleWrapper } from '@routes/digital-footprint/routes/assets/assets.styles'
import { AssetsExport } from '@routes/digital-footprint/routes/assets/components/assetExport'
import AssetsSkeleton from '@routes/digital-footprint/routes/assets/components/skeleton'
import { useDevicesPage } from './hooks/useDevicesPage'
import { DevicesTable } from './components/devicesTable'
import { DevicesHeader } from './components/devicesHeader'

const DEVICES_TABLE_COLUMN_COUNT = 4

const DevicesPage = () => {
    const {
        loading,
        filteredDevices,
        integrationAssets,
        scanInProgress,
        emptyDevicesMessage,
    } = useDevicesPage()

    return (
        <DashboardPage
            name="devices"
            loading={loading}
            hideScanInProgress
            skeleton={
                <AssetsSkeleton columnCount={DEVICES_TABLE_COLUMN_COUNT} />
            }
        >
            <TableWrapper>
                <TitleWrapper>
                    <Typography variant="m-regular">Devices</Typography>
                    <AssetsExport
                        assets={[...filteredDevices, ...integrationAssets]}
                        exportScope="devices"
                        scanInProgress={!!scanInProgress}
                    />
                    <InlineScanIndicator scanInProgress={!!scanInProgress} />
                </TitleWrapper>
                <DevicesHeader />
                <DevicesTable
                    assets={filteredDevices}
                    emptyDevicesMessage={emptyDevicesMessage}
                />
            </TableWrapper>
        </DashboardPage>
    )
}

export default DevicesPage
